import 'uni-pages';import 'uni-h5';import Vue from 'vue';
import App from './App';
import store from './store';
import public_tool from './common/public.js';
import PermissionManager from './utils/permission.js';
import DataManager from 'uni-data-manager';
import myloading from './components/loading/loading.vue';
import TwTabbar from '@/layout/TwTabbar.vue';
import TwLayout from '@/layout/TwLayout.vue';
import { api, request } from './api/index';
import Sensors from './js_sdk/Sensorsdata';


import './utils/common/sentryConfig.js';
import * as Sentry from '@sentry/vue';


// 神策埋点
Sensors.init();
Vue.prototype.$Sensors = Sensors;







Vue.component('myloading', myloading);
Vue.component('TwTabbar', TwTabbar);
Vue.component('TwLayout', TwLayout);
Vue.config.productionTip = false;
App.mpType = 'app';

function switch_loading(tf) {
  if (tf) {
    store.commit('switch_loading', tf);
  } else {
    store.commit('switch_loading');
  }
}
const dataManager = new DataManager();
Vue.prototype.$loading = switch_loading;
Vue.prototype.$store = store;
Vue.prototype.$app = public_tool;
Vue.prototype.$api = api;
Vue.prototype.$request = request;
Vue.prototype.$eventBus = new Vue();
Vue.prototype.$dataManager = dataManager;
Vue.prototype.$dataManager.dbName = 'ceekeeDB';

// let aliBIID = '';
// if (public_tool.plantId == '1028') {
//   aliBIID = 'bhdk8criw0@7ba9618868cbcc4';
// } else if (public_tool.plantId == '1033') {
//   aliBIID = 'bhdk8criw0@68743580efb064a';
// } else if (public_tool.plantId == '1035') {
//   aliBIID = 'bhdk8criw0@bbbfddda6a026cb';
// } else if (public_tool.plantId == '1020') {
//   aliBIID = 'bhdk8criw0@54c993a5a348b0c';
// }


// if(aliBIID){
// 	const BrowserLogger = require('alife-logger');
// 	const __bl = BrowserLogger.singleton({pid:aliBIID,appType:"web",imgUrl:"https://arms-retcode.aliyuncs.com/r.png?",sendResource:true,enableLinkTrace:true,behavior:true});
// }


// Sentry.init({
//   dsn: "https://b7c8aa931ac94ee98ca12fc0c2ace3bd@sentry.ceekee.com/4",
//   integrations: [new VueIntegration({ Vue, attachProps: true })],
// })



const currentUrl = window.location.href;
if (currentUrl.indexOf('#') > -1) {
  window.location.replace(currentUrl.replace(/#\//g, ''));
}


const app = new Vue({
  store,
  ...App,
});

app.$mount();